import { Box, BoxProps } from '@mui/material';
import { useDroppable } from '@dnd-kit/core';
import { CELL_HEIGHT, CELL_WIDTH } from '../../../config';
import { CellCoordinates } from '../../../types';
import { stringifyCellId } from '../../../utils';
import { useBoardContext } from '../../../hooks/useBoardContext';

type Props = {
  coordinates: CellCoordinates;
} & BoxProps;

export function GridCell({ coordinates, sx, ...props }: Props) {
  const {
    gridData: { timeSlots, assignees },
  } = useBoardContext();
  const { setNodeRef, isOver } = useDroppable({
    id: stringifyCellId(coordinates),
    data: {
      coordinates,
    },
  });

  return (
    <Box
      {...props}
      ref={setNodeRef}
      sx={{
        width: `${CELL_WIDTH}px`,
        height: `${CELL_HEIGHT}px`,
        backgroundColor: isOver ? '#EAECF0' : 'var(--Gray-100, #F2F4F7)',
        borderBottom:
          coordinates.row !== timeSlots.length - 1 ? '0.5px solid var(--Gray-300, #D0D5DD)' : null,
        borderRight:
          coordinates.column !== assignees.length - 1
            ? '0.5px solid var(--Gray-300, #D0D5DD)'
            : null,
        transition: 'background-color 0.2s ease',
        ...sx,
      }}
    />
  );
}
